import * as angular from "angular";
import {IController} from "angular";
import {RoutesViewSettingsServicesModel} from "../../../../routes/models/routes-view-settings.model";

export class ServicesSettingsPanelTemplateComponent implements IController {

  settings: RoutesViewSettingsServicesModel;
  panelRef: any;

  public settingsCopy: RoutesViewSettingsServicesModel;
  public enabledSections: {
    columns: boolean,
    load: boolean
  };

  $onInit() {
    this.settingsCopy = angular.copy(this.settings);
    this.enabledSections = {
      columns: true,
      load: true
    }
  }

  onChangeColumns(columnKey, isEnabled) {
    this.settingsCopy.columns[columnKey] = isEnabled;
  }

  onChangeLoad(loadKey, isEnabled) {
    this.settingsCopy.load[loadKey] = isEnabled;
  }


  onSubmit() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Submit', this.settingsCopy);
  }

  onReset() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Reset');
  }

  onCancel() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Cancel');
  }

}

angular
  .module('bringoz.admin.agents')
  .component('servicesSettingsPanelTemplate', {
    bindings: {
      settings: '<',
      panelRef: '<'
    },
    template: require('./services-settings-panel-template.html').default,
    controller: ServicesSettingsPanelTemplateComponent
  });
